/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2604
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.init_sensing_blocks = undefined
var r = require(/* 581 */"./2610/581")
exports.init_sensing_blocks = function (e) {
  var t = [
    {
      type: "get_time",
      message0: (0, r.i18n)("get_time"),
      args0: [
        {
          type: "field_dropdown",
          name: "op",
          options: [[(0, r.i18n)("year"), "year"], [(0, r.i18n)("month"), "month"], [(0, r.i18n)("date"), "date"], [(0, r.i18n)("week"), "week"], [(0, r.i18n)("hour"), "hour"], [(0, r.i18n)("minute"), "minute"], [(0, r.i18n)("second"), "second"]]
        }
      ],
      output: "Number",
      colour: (0, r.i18n)("GREEN_3"),
      inputsInline: true
    }, {
      type: "get_timer",
      message0: (0, r.i18n)("timer"),
      args0: [],
      output: "Number",
      colour: (0, r.i18n)("GREEN_3"),
      inputsInline: true
    }, {
      type: "reset_timer",
      message0: (0, r.i18n)("reset_timer"),
      previousStatement: true,
      nextStatement: true,
      colour: (0, r.i18n)("GREEN_3"),
      inputsInline: true
    }
  ]
  e.define_blocks_with_json_array(t)
  Object.assign(e.blocks_xml, {
    get_time: "<block type=\"get_time\"/>",
    get_timer: "<block type=\"get_timer\"/>",
    reset_timer: "<block type=\"reset_timer\"/>"
  })
}
